var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 47.1875,
    height: 9.71875,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 9.71875,
    opacity: 0,
    width: 47.1875,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1562 9.6875C44.8438 9.6875 47 7.53125 47 4.84375C47 2.15625 44.8438 0 42.1562 0C39.5 0 37.3125 2.15625 37.3125 4.84375C37.3125 7.53125 39.5 9.6875 42.1562 9.6875Z",
    fill: "#8e8e93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 9.6875C26.1875 9.6875 28.3438 7.53125 28.3438 4.84375C28.3438 2.15625 26.1875 0 23.5 0C20.8125 0 18.6562 2.15625 18.6562 4.84375C18.6562 7.53125 20.8125 9.6875 23.5 9.6875Z",
    fill: "#8e8e93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84375 9.6875C7.53125 9.6875 9.6875 7.53125 9.6875 4.84375C9.6875 2.15625 7.53125 0 4.84375 0C2.15625 0 0 2.15625 0 4.84375C0 7.53125 2.15625 9.6875 4.84375 9.6875Z",
    fill: "#8e8e93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.a334f287ec77525477b923ed74425ca3.svg";
export { ForwardRef as ReactComponent };